import React, { useState } from 'react';
import { QueryClient, QueryClientProvider as ReactQueryClientProvider } from '@tanstack/react-query';

export interface Props {
    children: React.ReactNode;
}

export const QueryClientProvider = ({ children }: Props) => {
    const [queryClient] = useState(() => new QueryClient());

    return <ReactQueryClientProvider client={queryClient}>{children}</ReactQueryClientProvider>;
};
